// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-width: var(--file-upload-picker-border-width);
  border-style: var(--file-upload-picker-border-style);
  width: var(--file-upload-picker-width-full);
  padding: var(--file-upload-picker-padding);
  border-color: var(--file-upload-picker-border-color);
  background-color: var(--file-upload-picker-background-color);
  transition: border-color 0.2s;
}
:host:hover, :host.drag {
  border-color: var(--file-upload-picker-border-hover-color);
}
:host .generic-file-select-input {
  position: absolute;
  opacity: 0;
  width: var(--file-upload-picker-width-full);
  height: var(--file-upload-picker-height-full);
  top: var(--file-upload-picker-top);
  left: var(--file-upload-picker-left);
  cursor: pointer;
}
:host .generic-file-select-preview-image {
  width: var(--file-upload-picker-width-full);
  object-fit: contain;
  object-position: center;
}
:host .generic-file-select-label {
  font-weight: bold;
  color: var(--file-upload-picker-color);
  transition: color 0.2s;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/wrappers/lib/fileUpload-picker/fileUpload-picker.component.sass"],"names":[],"mappings":"AAAC;EACC,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oDAAA;EACA,oDAAA;EACA,2CAAA;EACA,0CAAA;EAGA,oDAAA;EACA,4DAAA;EACA,6BAAA;AADF;AAGE;EACE,0DAAA;AADJ;AAGE;EACE,kBAAA;EACA,UAAA;EACA,2CAAA;EACA,6CAAA;EACA,kCAAA;EACA,oCAAA;EACA,eAAA;AADJ;AAGE;EACE,2CAAA;EACA,mBAAA;EACA,uBAAA;AADJ;AAGE;EACE,iBAAA;EACA,sCAAA;EACA,sBAAA;AADJ","sourcesContent":["\\:host\n  position: relative\n  display: flex\n  flex-direction: column\n  justify-content: center\n  align-items: center\n  border-width: var(--file-upload-picker-border-width)\n  border-style: var(--file-upload-picker-border-style)\n  width: var(--file-upload-picker-width-full)\n  padding: var(--file-upload-picker-padding)\n  // padding: 25px\n  // min-height: 167px\n  border-color: var(--file-upload-picker-border-color)\n  background-color: var(--file-upload-picker-background-color)\n  transition: border-color 0.2s\n\n  &:hover, &.drag\n    border-color: var(--file-upload-picker-border-hover-color)\n\n  .generic-file-select-input\n    position: absolute\n    opacity: 0\n    width: var(--file-upload-picker-width-full)\n    height: var(--file-upload-picker-height-full)\n    top: var(--file-upload-picker-top)\n    left: var(--file-upload-picker-left)\n    cursor: pointer\n\n  .generic-file-select-preview-image\n    width: var(--file-upload-picker-width-full)\n    object-fit: contain\n    object-position: center\n\n  .generic-file-select-label\n    font-weight: bold\n    color: var(--file-upload-picker-color)\n    transition: color 0.2s\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
